import React, { useContext } from "react";
import { AuthContext } from '../../contexts/AuthContext'
import { Col, Row, Button } from "reactstrap";
import Footer from "../../layout/Footer/Footer";
import Header from "../../layout/Header/Header";

function BotonesComprasDirectas() {
  const { user } = useContext(AuthContext);
  return (
    <>
          <Header />
          {user.menu_compras ?(
      <div className="container">
        <br />
        <br />
        <Row >
        {/* <Col md={4} align="center">
            {user.menu_proveedores ?(
            <Button href="/Proveedores" className="botonesMenu" color="success">
            <i class="fas fa-dolly fa-7x"></i>
              <br />
              <br />
              Proveedores
            </Button>
            ): <Button disabled className="botonesMenu" color="success">
            <i class="fas fa-dolly fa-7x"></i>
              <br />
              <br />
              Proveedores
            </Button> }
          </Col> */}
        <Col md={4} align="center">
          {user.menu_oc ?(
            <Button href="/ListadoOrdenesCompraDirectas" className="botonesMenu" color="success">
              <i class="fas fa-shopping-basket fa-7x"></i>
              <br />
              <br />
              Ordenes de Compra
              <br /> Directa
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-shopping-basket fa-7x"></i>
          <br />
          <br />
          Ordenes de Compra
              <br /> Directa
        </Button> }
          </Col>
          <Col md={4} align="center">
          {user.menu_compras ?(
            <Button href="/ListadoComprasDirectas" className="botonesMenu" color="success">
              <i class="fas fa-cart-plus fa-7x"></i>
              <br />
              <br />
              Recepción
              <br /> Directa
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-cart-plus fa-7x"></i>
          <br />
          <br />
          Recepción
              <br /> Directa
        </Button> }
          </Col>
        </Row>
        <br/>
        {/* <Col md={4} align="center">
          {user.menu_devolucionesProveedores ?(
            <Button href="/ListadoDevolucionesProveedores" className="botonesMenu" color="success">
              <i class="fas fa-undo-alt fa-7x"></i>
              <br />
              <br />
              Devoluciones
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-undo-alt fa-7x"></i>
          <br />
          <br />
          Devoluciones
        </Button> }
          </Col> */}
      </div>
      ): undefined } 
      
    </>
  );
}

export default BotonesComprasDirectas;
